<template>
  <div>
    <div class="border-bar">
      <div class="left-item">
        <a class="button app-primary" @click="$router.back()">
          <i class="fas fa-chevron-left"></i>
          GO Back
        </a>
        <p class="title is-hidden-x">Your Favorites</p>
      </div>
      <div class="right-item">
        <div class="buttons has-addons">
           <span class="button"
                 v-on:click="filterTileView(true)"
                 v-bind:class="{ 'is-active': tileView}">
                        Tile View
                    </span>
          <span class="button"
                v-on:click="filterTileView(false)"
                v-bind:class="{ 'is-active': !tileView}">
                    Map View
                    </span>
        </div>
<!--        <a class="button app-accent" v-if="!tileView">-->
<!--          <i class="fas fa-sync"></i>-->
<!--          Reset View-->
<!--        </a>-->
      </div>
    </div>
    <div class="favorites-container">
      <div class="container" v-if="favoriteHnl && tileView">
        <div class="columns is-multiline is-variable is-6">
          <div class="column is-3-widescreen is-4-desktop is-6-tablet is-12-mobile" v-for="hnlSummary in favoriteHnl">
            <app-package-card v-bind:hnlSummary="JSON.parse(JSON.stringify(hnlSummary))"></app-package-card>
          </div>
        </div>
      </div>
      <app-favorites-map v-if="!tileView && favoriteHnl" :favoriteHnl="favoriteHnl"></app-favorites-map>

      <!--      <div class="cards-list">-->
      <!--        <h3>Favorites</h3>-->
      <!--        <div class="cards">-->
      <!--          <app-package-card v-if="favoriteHnl.length > 0" v-on:locatePackage="activeLot = $event" v-for="hnlsummary in favoriteHnl"-->
      <!--                            :hnlSummary="JSON.parse(JSON.stringify(hnlsummary))"></app-package-card>-->
      <!--          <p v-if="favoriteHnl.length === 0">You have not saved any favorites</p>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
  </div>
</template>

<script>
import PackageCard from "@/components/favorites/FavoritePackageCards";
import FavoritesMap from "@/components/favorites/FavoritesMap";
import favorite from "@/store/favorite";

export default {
  name: 'app-favorites',
  data() {
    return {
      favoriteHnl: [],
      activeLot: null,
      lotIds: [],
      favoriteHomes: [],
      count: 0,
      loaded: false,
      loading: true,
      tileView: true
    }
  },
  components: {
    'app-package-card': PackageCard,
    'app-favorites-map': FavoritesMap
  },
  props: {
    showFavorites: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    favoriteHnl: {
      handler(val, oldval) {
        if (val) {
          const ids = this.favoriteHnl.map(item => item.lotproductcpid);
          this.lotIds = ids.filter((value, index, self) => {
            return self.indexOf(value) === index
          });
        }
      },
      deep: true
    }
  },
  mounted() {
    this.favoriteHnl = this.$store.getters.favoriteHnlDetail;
    this.fetchFavorites();
  },
  methods: {
    fetchFavorites: function () {
      this.sub = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setFavoriteHnlDetailList') {
          this.favoriteHnl = state.favoriteStore.favoriteHnlDetail;
        }
      })
      this.$store.dispatch('fetchAllFavoritePackageDetail');
    },

    filterTileView: function (view) {
      this.tileView = view
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/favorites/Favorites.vue